import { useEffect, useCallback } from 'react';
import { redirectToGpaAccount } from '../redirectToGpaAccount';

const log = (msg: string) => console.log(`[GPA Hook]: ${msg}`);

interface UseGpaRedirectOptions {
    autoRedirect?: boolean;
    featureFlag: boolean;
    accountNumber: string | undefined;
}

export const useGpaRedirect = ({
    autoRedirect = false,
    featureFlag,
    accountNumber
}: UseGpaRedirectOptions ) => {
    const redirect = useCallback(() => {
        if (!featureFlag) {
            log("Feature Flag disabled. Not redirecting")
            return;
        }
        if (!accountNumber) {
            log("Missing Account Number in url")
            return;
        }

        redirectToGpaAccount(accountNumber);
    }, [featureFlag, accountNumber]);

    useEffect(() => {
        if (autoRedirect && featureFlag) {
            redirect();
        }
    }, [autoRedirect, featureFlag, redirect]);
    return redirect;
}
